/**
 * @desc 入库
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(body: defs.fulfilment.FulfilmentInRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/test/fulfilmentIn`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
